import { render, staticRenderFns } from "./add-more-button.vue?vue&type=template&id=33d50d80&scoped=true"
import script from "./add-more-button.vue?vue&type=script&lang=ts"
export * from "./add-more-button.vue?vue&type=script&lang=ts"
import style0 from "./add-more-button.vue?vue&type=style&index=0&id=33d50d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d50d80",
  null
  
)

export default component.exports